import { Component, effect, inject, model, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ITipoPagoData } from '@core/interfaces/entidades/tipoPago.entidad';
import { TipoPagoApiService } from '@core/services/api/tipo-pago-api.service';
import { CardTipoPago } from '@shared/components/card-tipo-pago/card-tipo-pago';
import { InputBuscador } from '@shared/components/input-buscador/input-buscador';
import { UiButton, UiDialog } from '@shared/components/ui';
import { CrearTipoPago } from '@shared/components/crear-tipo-pago/crear-tipo-pago';
import { AppService } from '@shared/services/app.service';
import { SucursalService } from '@shared/services/sucursal.service';
import { logger } from '@shared/utils/functions.utils';

@Component({
  selector: 'app-tipo-pago',
  imports: [CardTipoPago, InputBuscador, UiButton, UiDialog, CrearTipoPago],
  templateUrl: './tipo-pago.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tipo-pago.css',
})
export class TipoPago implements OnInit {
  constructor() {
    effect(() => {
      if (this.sucursalService.sucursalReady() && this.appService.authReady()) {
        this.tipoPagoApiService.cargarTodos().subscribe((tiposPago) => {
          this.tipoPagos.set(tiposPago);
        });
      }
    });
  }
  ngOnInit(): void {
    this.appService.setPanelHeader({
      title: 'Gestión de Tipos de Pago',
      subtitle: 'Aquí puedes gestionar los tipos de pago de la empresa',
      showBackButton: true,
      icon: 'bi bi-credit-card',
    });
  }
  // servicios
  private appService = inject(AppService);
  private tipoPagoApiService = inject(TipoPagoApiService);
  private sucursalService = inject(SucursalService);

  // datos
  tipoPagos = model<ITipoPagoData[]>([]);
  busquedaTipoPago: string = '';
  modal_crear_tipo_pago = model(false);

  // métodos
  onBuscarTipoPago() {
    logger('Buscar tipo de pago:', this.busquedaTipoPago);
  }
  closeCrearTipoPago(data?: ITipoPagoData) {
    this.modal_crear_tipo_pago.set(false);
    if (data) {
      this.tipoPagos.update((tiposPago) => [...tiposPago, data]);
    }
  }
}
